import type { IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box } from "@mui/material";
import React from "react";

import { Typography } from "components/shared/Typography";

import ExternalPageCard from "../ExternalPageCard";
import { useStyles } from "./styles";

interface IExternalStateMessageProps {
  title: string;
  headerTitle?: string;
  description: string;
  icon: IconDefinition;
  tip?: string;
  dataCy?: string;
}

const ExternalStateMessage: React.FC<IExternalStateMessageProps> = ({
  title,
  headerTitle,
  description,
  icon,
  tip,
  dataCy,
}) => {
  const { classes } = useStyles();

  return (
    <ExternalPageCard
      pageTitle={title}
      headerTitle={headerTitle}
      dataCy={dataCy}
    >
      <Box className={classes.iconCircle}>
        <FontAwesomeIcon icon={icon} />
      </Box>

      <Typography className={classes.title}>{title}</Typography>
      <Typography
        className={classes.description}
        dangerouslySetInnerHTML={{ __html: description }}
      />

      {tip ? <Box className={classes.tip}>{tip}</Box> : null}
    </ExternalPageCard>
  );
};

export default ExternalStateMessage;
